import React, { Component } from 'react';
 import "../styles/Footer.css"
class Footer extends Component {
  render() {
    return (
      <div id="links">
      <ul>
         <li>About</li>
         <li>Blog</li>
         <li>Jobs</li>
         <li>Help</li>
         <li>API</li>
         <li>Privacy</li>
         <li>Terms</li>
         <li>Top Accounts</li>
         <li>Hashtags</li>
         <li>Locations</li>
      </ul>
      <div id="copyright">
         <select name="" id="lang">
            <option value="eng">English</option>
         </select>
         &copy; 2021 Instagram by Thendo Makherana
      </div>
   </div>  
    );
  }
}
 
export default Footer;